import type { FaireProductEntity } from "../../entity_types/product";

export const p_8attxksy9u: FaireProductEntity = {
  token: "p_8attxksy9u",
  type: "product",
  name: "GAMEDAY Sports Two-Toned Dad Cap with Vegan Leather Bill",
  brandToken: "b_48we1z8tb5",
  brandName: "Olive & Pique",
  imageUrl:
    "https://cdn.faire.com/fastly/db049d80b5943837ad04eff46db5028cd62cfac4e6eae962ed18900e679b3270.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d3a249fe5bbd9ed63712b8fc380935f8ca58407d2107218f420d37e3ee206354.jpeg",
    "https://cdn.faire.com/fastly/c8530a4269c19c6ac35b81cb57ef9ea8ec3cc57c3eade902b0f276f05eb294d8.jpeg",
    "https://cdn.faire.com/fastly/33aa295023420609bafd6098b42baa746592aa393366dda95dda40222302babc.jpeg",
    "https://cdn.faire.com/fastly/56dc5de9f95d16e3bdae588a68c3ef210956700366a832c7cbd5843996e07701.jpeg",
    "https://cdn.faire.com/fastly/faa6d78a73f1bc1c521ad94ea55ff645e952f0a37533956570871b95a4e43001.jpeg",
    "https://cdn.faire.com/fastly/2972b6ff29b840a7914717541b804760ba5ebf75872da71dc74e09e13463f7e0.jpeg",
    "https://cdn.faire.com/fastly/c41df05f543824ccf73f8f315f73a413900aae1181a5e651b351be6b26acef83.jpeg",
    "https://cdn.faire.com/fastly/6e72932b2f4afd817e91d1a6396a4646ef4ada7cd671c200ebc0ce1b17d8dc70.jpeg",
    "https://cdn.faire.com/fastly/8900ac2a66987d5c1877f5676fb19e9f1c0a9a6098302eb3c6a6c1aaecfb006d.jpeg",
    "https://cdn.faire.com/fastly/d268eedcaeb0b7312086cdc3efc0d0ac749fe9ac91aacf3c1eda18f312bcbfc7.jpeg",
    "https://cdn.faire.com/fastly/2d79da640d1309d1fad6425aa302526314c5b52b7b5264661baa6a64f5993287.jpeg",
    "https://cdn.faire.com/fastly/89e693d9319a017c287bb0a23369e127269ebb17c9d108d110167b5fd4175529.jpeg",
    "https://cdn.faire.com/fastly/17713f1b81798a391f21c2022990b12f677b57c76127538acd595873ca37ed88.jpeg",
    "https://cdn.faire.com/fastly/6448ae19d6b93dccc757f7cd636f3394b1b30e963e0eb964d2109102b4a1f903.jpeg",
    "https://cdn.faire.com/fastly/2eea7ecdc3791e27fda7fba4d3a688b8c70ec83b58dba8da70a493342bdb4043.jpeg",
    "https://cdn.faire.com/fastly/ae51ba24ee9befc595b313f7acca43076ddc62c5ac532edcdf7343d4e20e12cf.jpeg",
    "https://cdn.faire.com/fastly/8e7d7f765f7e65bc296daa6d331b1d06d28230606ff80eb916733df899c50978.jpeg",
    "https://cdn.faire.com/fastly/3ad17ecfa12436cb8ee4a47f617220916a605b1ee32d85cc6010d7164e5fa939.jpeg",
  ],
  priceDollars: 21.48,
  description:
    'Bejeweled glitz with "GAMEDAY" and sports charms on cotton dad cap with leatherette detail. \n\nBASEBALL, FOOTBALL, BASKETBALL, SOCCER, HOCKEY, GOLF',
  tags: [],
  msrpDollars: 80.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:00.097Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
